export const translation = {
  SEARCH_CATALOG: "Search Catalog",
  MY_SETUP: "Account Details",
  CONTACT_US: "Contact Us",
  HELP: "Help",
  LOGOUT: "Logout",
  ORDER_FAVORITES: "Order Favorites",
  QUICK_ORDER: "Quick Order",
  ORDER_BANDS: "Order Bands",
  CATALOG: "Shop Catalog",
  SAVED_CARTS: "Saved Carts",
  MY_CART: "Cart",
  MY_ORDERS: "Order History",
  MY_STATEMENT: "Manage Payments",
  WELCOME: "Welcome",
  LOGIN_ID: "Login ID",
  ACCOUNT_NUMBER: "Account Number",
  ADDRESS: "Address",
  PHONE: "Phone",
  FAX: "Fax",
  PRICE_DISCOUNT: "Price Discount",
  SHOW_CUSTOMER_DETAILS: "Show Customer Details",
  HIDE_CUSTOMER_DETAILS: "Hide Customer Details",
  MY_REWARDS: "My Rewards",
  YOUR_PRODUCTS: "Your Products",
  MANAGE_ACCOUNTS: "Manage Accounts",
  //CATALOG PAGE
  PRODUCTS: "products",
  HOME: "Home",
  //Saved Carts

  CART_NUMBER: "Cart Number",
  CART_NAME: "Cart Name",
  LAST_UPDATED: "Last Updated",
  TOTAL: "Total",
  ACTIONS: "Actions",
  CREATE_CART: "Create Cart",
  SAVED_CARTS: "Saved Carts",
  VIEW_CART_DETAILS: "View cart details",
  SET_AS_CURRENT_CART: "Set as current cart",
  RENAME_CART: "Rename cart",
  DELETE_CART: "Delete cart",
  ACTIVE_CART_MESSAGE: "This is your active cart",
  LOCK_CART_MESSAGE: "This cart is locked by logon ID",
  LOCK_CART_SELF_MESSAGE:
    "You have locked this cart. No one else may edit this cart.",
  RENAME: "Rename",
  DELETE: "Delete",
  CANCEL: "Cancel",
  PRIVATE_CART_MESSAGE:
    "This cart is private. Unlock to allow others to see this cart.",
  UNLOCK_CART: "Unlock cart",
  TAKE_OVER_LOCK: "Take over lock",
  LOCK_CART: "Lock cart",
  CART_NAME: "Cart name",
  CREATE: "Create",
  CUSTOMER_SUPPORT: "Customer Support",
  YOUR_ACCOUNT: "Your Account",
  ITEMS: "items",
  //Product Details Page
  OVERVIEW: "Overview",
  SPECIFICATIONS: "Specifications",
  DETAILS: "Details",
  VIEW_ALL_DETAILS: "View all details",
  VIEW_LEGAL_DISCLAIMER: "View Legal Disclaimer",
  PRODUCTS_AVAILABLE: "Products available",
  THREEM_SITE_REDIRECT_MSG: "Click here to see this product on Solventum.com",
  LEGAL_DISCLAIMER: "Legal Disclaimer",
  ENDORSEMENT_MSG:
    "*Solventum version of this prescription. No endorsement by the Doctor is implied.",
  SEARCH_RESULTS_FOR: "Search results for",
  CATALOG_PRODUCT: "Catalog",
  SEARCH_RESULTS: "Search results",
  //My Rewards Page
  SAVINGS_THIS_YEAR: "savings this year",
  CURRENT_3M: "Current Solventum",
  TM: "TM",
  CLARITY: "Clarity",
  DISCOUNT_STATUS: "Aligner Earned Discount Status",
  CLARITY_ALIGNERS_CASES: "Clarity Aligners Cases",
  OTHER_PRODUCT_PURCHASES: "Other Product Purchases",
  SPEND: "Spend",
  IN_PRODUCT_PURCHASES: "in product purchases",
  ADD: "Add",
  OR: "OR",
  CLARITY_ALIGNERS_ORDERS: "Clarity Aligners Orders",
  DATE: "Date",
  INVOICE_NUMBER: "Invoice Number",
  ORDER_NUMBER: "Order Number",
  QUALIFYING_CASES: "Qualifying Cases",
  QUALIFYING_PURCHASES: "Qualifying Purchases",
  OTHER_ORTHODONTIC_PURCHASES: "Other Orthodontic Purchases",
  FAQS: "FAQS",
  //MAC BOB
  BUYING_FOR: "Buying for",
  BUY_ON_BEHALF: "Buy on behalf of",
  RETURN_TO_HEADQUARTERS: "Return to headquarters",

  //Shopping cart
  SHOPPING_CART: "Shopping Cart",
  PRINT_QUOTE: "Print Quote",
  CART_LOCKED: "Cart Locked",
  CART_UNLOCKED: "Cart Unlocked",
  SELECT_ITEMS: "Select item(s) to",
  APPLY_A_DISCOUNT: "Apply a discount",
  APPLY_DISCOUNT: "Apply discount",
  DELETE: "Delete",
  ESTIMATED_SUBTOTAL: "Estimated Subtotal",
  ITEMS: "items",
  SHIPPING_MESSAGE:
    "Shipping and tax will be estimated after your order is placed.",
  PROCEED_TO_CHECKOUT: "Proceed to checkout",
  NET_PRICE_DESCRIPTION:
    "Your Net Price includes your personalized pricing program.",
  TYPE: "Type",
  SIZE: "Size",
  QUANTITY: "Quantity",
  EDIT_ORDER: "Edit Order",
  COMMENTS: "Comments",
  CART_EMPTY_MESSAGE: "Your cart is empty!",
  SHOP_YOUR_FAVORITES: "Shop your favorites",
  SHOP_ORDER_HISTORY: "Shop order history",
  LOADING_YOUR_CART: "Loading your cart...",
  THE_ORDER_IS_LOCKED:
    "The order is locked, To edit the order, contact your Solventum Field Representative listed on the Contact Us page.",
  THE_ORDER_IS_UNLOCK: "The order is unlocked, click Lock to edit the order.",
  TO_APPLY_A_DISCOUNT:
    "To apply a discount, select one or more product(s) and a discount code.",

  //Checkout page
  CHECKOUT: "Checkout",
  PLACE_ORDER: "Place Order",
  SHIPPING_CONTACT_INFO_HEADER: "Shipping and contact information",
  PLACING_ORDER_HEADER: "Who is placing this order?",
  SHIPPING_ADDRESS: "Shipping address",
  PRIMARY_CONTACT_INFO_HEADER: "Primary contact information",
  CONFIRMATION_HEADER:
    "Would you like to send a confirmation email to anyone else?",
  RECIPIENT_EMAIL_HEADER: "Recipient(s) email",
  ENTER_EMAIL: "Enter Email",
  ADD_RECIPIENT: "Add Recipient",
  ADD_RECIPIENT_EMAIL_MESSAGE: "Please add recipient Email Address",
  VALID_EMAIL_ADDRESS_MESSAGE: "Please enter valid Email Address",
  PAYMENT_INFO_HEADER: "Payment information",
  CARD: "Card",
  ACH: "ACH",
  BILL_MY_ACCOUNT: "Bill my account",
  YOUR_CARDS: "Your cards",
  EXPIRES: "Expires",
  NO_CARD_MESSAGE: "You currently have no cards on file.",
  ADD_CARD_MESSAGE:
    "Add a card or select a different payment method to place your order.",
  ADD_NEW_CARD: "Add new card",
  ADD_CARD: "Add card",
  ACH_PAYMENT_HEADER: "Your ACH payment options",
  NO_ACH_MESSAGE: "You currently have no ACH payment methods set up.",
  ADD_ACH_MESSAGE:
    "Add a ACH account or select a different payment method to place your order.",
  ADD_NEW_ACH: "Add new ACH",
  ADD_ACH: "Add ACH",
  PAYMENT_TERMS: "Payment Terms",
  DEFAULT_PAYMENT_METHOD: "Default Payment Method",
  BILLING_ADDRESS: "Billing Address",
  NO_BILL_MY_ACCOUNT_MESSAGE:
    "You currently are not set up for account billing.",
  CUSTOMER_SERVICE_MESSAGE:
    "Contact customer service or select a different payment method to place your order.",
  REVIEW_PURCHASE_HEADER: "Review purchase",
  PO_NUMBER_LABEL: "Do you have a PO number for this order?",
  SPECIAL_INSTRUCTIONS_LABEL:
    "Do you have any special instructions for this order?",
  CHARACTER_LIMIT_MESSAGE: "Please enter up to 255 characters.",
  CHARACTERS_LEFT: "Characters left:",
  REVIEW_ITEMS_MESSAGE: "Review items one last time before placing your order.",
  UNIT_PRICE: "Unit Price",
  LIST_PRICE: "List Price",
  LIST_UNIT_PRICE: "List Unit Price",
  NET_UNIT_PRICE: "Net Unit Price",
  NET_PRICE: "Net Price",
  TOTAL_PRICE: "Total Unit Price",
  CUSTOM_BANDS_HEADER: "Custom welded bands (prescription bands)",
  EDIT_ITEMS_MESSAGE: "Edit Items in cart",
  EMAIL_VALIDATION_MESSAGE: "Please enter your email to place your order.",
  PAYMENT_VALIDATION_MESSAGE:
    "Please select payment method to place your order.",
  PAYMENT_METHOD_NOT_AVAILABLE_MESSAGE:
    "This payment method is not available for this account. Select a different payment method or contact customer service.",
  PAYMENT_SETUP_INIT_FAILED_MESSAGE:
    "Unable to initialize payment setup for this account. Select a different payment method or contact customer service.",
  ENTER_PO_NUMBER: "Enter PO number",
  DESCRIBE_YOUR_REQUEST: "Describe your request here...",
  PREPARING_YOUR_ORDER: "Preparing your order...",
  RESTORE_DEFAULT_RECIPIENT: "Restore default recipient",
};
